import { gql } from '@apollo/client';

export const GET_FINLEY_AI_THREADS = gql`
  query GetFinleyAiThreads($userId: UUID!) {
    getFinleyAiThreads(userId: $userId) {
      threads
    }
  }
`;

export const GET_FINLEY_AI_THREAD_WITH_PROMPT_RESPONSES = gql`
  query GetFinleyAiThreadWithPromptResponses($finleyAiThreadId: UUID!) {
    getFinleyAiThreadWithPromptResponses(finleyAiThreadId: $finleyAiThreadId) {
      threadWithPromptResponses
    }
  }
`;

export const GET_FINLEY_AI_PROMPT_RESPONSE = gql`
  query GetFinleyAiPromptResponse($finleyAiPromptResponseId: UUID!) {
    getFinleyAiPromptResponse(
      finleyAiPromptResponseId: $finleyAiPromptResponseId
    ) {
      promptResponse
    }
  }
`;

export const PRODUCE_FINLEY_AI_WORKLEASE = gql`
  mutation ProduceFinleyAiWorklease($params: FinleyAiRequest!) {
    produceFinleyAiWorklease(params: $params) {
      thread
    }
  }
`;

export const GET_ATHENA_SQL_GENERATION_SIGNED_URLS = gql`
  query getAthenaSqlGenerationSignedUrls($serializedParams: String!) {
    getSignedDownloadUrls(
      feature: "athenaSqlGeneration"
      serializedParams: $serializedParams
    ) {
      url
      filename
    }
  }
`;

export const GET_FINLEY_AI_ATHENA_SQL_GENERATION_PROMPT_RESULT_PREVIEW = gql`
  query getFinleyAiAthenaSqlGenerationPromptResultPreview(
    $finleyAiPromptResponseId: UUID!
    $numberOfPreviewRows: Int
  ) {
    getFinleyAiAthenaSqlGenerationPromptResultPreview(
      finleyAiPromptResponseId: $finleyAiPromptResponseId
      numberOfPreviewRows: $numberOfPreviewRows
    )
  }
`;
